import React, {useEffect, useState} from "react";
import axios from 'axios';
import Modal from 'react-modal';
import {toast} from 'react-toastify';
import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ENUMS from "../../utils/ENUMS.js"
import {BASE_URL} from '../../config.json'
import {NavLink} from "react-router-dom";

const token = localStorage.getItem(ENUMS.AUTH);
Modal.setAppElement("#root");

let get_id = [];
const CancelAccount = (props) => {
    const [Id, SetId] = useState(null);
    const [paymentMethod, setPaymentMethod] = useState(null);

    const [modalIsOpen, setModalIsOpen] = useState(false)

    const RenewalAccount = () => {

        let ID = get_id[0].id;

        if (Id === 'inactive') {
            const config = {
                headers: {Authorization: `Bearer ${token}`}
            };
            const params = {
                "payment_details": {
                    "subscription_id": props.Card.CurrentSubscription.subscription_mapping.subscription.id,
                    "payment_method_id": paymentMethod.payment_method_id
                }
            }
            //save api
            axios.post(`${BASE_URL}/club/subscrption/`, params, config)
                .then(res => {
                    // console.log(res, "RESPONSE")
                    if (res.status == 200) {
                        toast.success("Account Renewed SuccessFully");
                        props.Card.refreshList()
                    } else {
                        toast.error("Unable  to Renewal Account");

                    }

                })
                .catch(err => {
                    toast.error('Something Wents Wrong Please Give Proper details')
                    console.log(err)
                })
        } else {
            toast.error("Unable  to Renewal Account");
        }
    }


    const handleAccountCancellations = () => {
        let ID = get_id[0].id;

        axios.delete(`${BASE_URL}/club/subscrption/`, {
            headers: {
                Authorization: `Bearer ${token}`
            },
            data: {
                id: ID
            }
        }).then(res => {
            if (res.status == 200) {
                toast.success("Your Subscription is cancelled successfully.");
                setModalIsOpen(false)
                props.Card.refreshList()
            } else {
                toast.error("Unable to  Delete");

            }

        })
            .catch(err => {
                toast.error('Something Wents Wrong Please Give Proper details')
                console.log(err)
            })

    }

    const Cancel = () => {
        setModalIsOpen(true)
    }

    useEffect(() => {
        if (props.Card.CurrentSubscription) {
            get_id.push(props.Card.CurrentSubscription)
            SetId(props.Card.CurrentSubscription.subscription_mapping.status.value)
            setPaymentMethod(props.Card.CurrentSubscription.subscription_mapping.payment_method)
        }
    }, [props])


    if(!Id) return null

    const isCancellable = Id === 'active' && props.Card?.CurrentSubscription?.is_cancellable

    return (
        <>

            <div className="member_cancle">
                <h2 className="text-jost-sb-24">{Id === 'active' ? (isCancellable ? "End Benefits:" : ""): "Gain Benefits:"}</h2>
                <div className="member__cancle-link">
                    {
                        Id === 'active'
                            ?
                            (
                                isCancellable
                                    ?
                                    <button className="res-btn-primary" onClick={Cancel}>Cancel Subscription</button>
                                    :
                                    null
                            )
                            :
                            <NavLink to="/golf-pay" target="_self" className="res-btn-primary">
                                Renew Subscription
                            </NavLink>
                    }
                    <ToastContainer/>
                    <Modal isOpen={modalIsOpen} className="custom-modal cancel_sub_modal"
                           style={{
                               overlay: {
                                   zIndex: '2',
                                   backgroundColor: 'rgba(93.3,93.3,93.3,0.6)',
                                   // opacity:'0.5'


                               },
                               content: {
                                   position: 'absolute',
                                   top: '45%',
                                   left: '20%',
                                   right: '20%',
                                   bottom: '10%',
                                   border: '1px solid #ccc',
                                   background: '#fff',
                                   overflow: 'auto',
                                   WebkitOverflowScrolling: 'touch',
                                   borderRadius: '4px',
                                   outline: 'none',
                                   padding: '20px',
                                   display: 'flex',
                                   alignItems: 'center',
                                   justifyContent: 'center',
                                   flexDirection: 'column',
                                   boxShadow: 'rgb(0 0 0 / 35%) 0px 5px 15px',
                                   transition: 'all 3s',
                                   transitionTimingFunction: 'linear',


                               }
                           }}
                    >
                        <button className="modal-content--cross" onClick={() => setModalIsOpen(false)}>
                            <img src={require("../../../src/assets/images/cross/Group 6926.svg").default} alt=""/>
                        </button>
                        <div className="modal_billing">


                            <div className="modal-content custom-modal" style={{boxShadow: "none", border: "none"}}>

                                <h1 className="modal-content--title text-jost-sb-50 m_r-h1">Are you sure?</h1>
                                <p className="modal-content--para text-ops-rg-16">Are you sure you want to end your
                                    benefits? This will only end your benefits when it comes round to renewal, you will
                                    continue to have access until your account closing date.</p>
                                <div className="modal-content--links">
                                    <button
                                        className="res-btn-ternary m_r_btn"
                                        onClick={() => setModalIsOpen(false)}>I WANT TO KEEP MY BENEFITS
                                    </button>
                                    <button
                                        className="res-btn-primary m_r_btn"
                                        onClick={handleAccountCancellations}>I DO NOT WANT MY BENEFITS
                                    </button>
                                </div>
                            </div>
                        </div>
                    </Modal>
                </div>

            </div>


        </>
    );

};
export default CancelAccount;
